import { ConfirmationService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';

export const leavePageConfirmationDialog = (
  confirmationService: ConfirmationService,
  translateService: TranslateService
) => {
  return new Promise<boolean>((resolve) => {
    confirmationService.confirm({
      message: translateService.instant('changes_will_be_lost'),
      header: translateService.instant('confirm_navigation'),
      icon: 'pi pi-exclamation-triangle',
      defaultFocus: undefined,
      acceptButtonStyleClass:
        'p-button-danger p-button-outlined p-button-sm app-confirm-danger',
      rejectButtonStyleClass: 'p-button-secondary p-button-outlined p-button-sm',
      acceptLabel: translateService.instant('nav_confirm_yes'),
      rejectLabel: translateService.instant('nav_confirm_no'),
      accept: () => resolve(true),
      reject: () => resolve(false),
    });
  });
};
